<div #dialog class="relative dialog-wrapper p-1" role="dialog" data-test-id="dialog_request_name"
     cdkTrapFocus>
  <button type="button" mat-dialog-close
          class="reset-button absolute t-0 r-0 icon icon-close close"
          (click)="close()"
          data-test-id="button_close_dialog"></button>
  <h3 mat-dialog-title
      class="medium color-black">{{'module.requests.text.request-name' | translate}}</h3>

  <form [formGroup]="form">
    <mat-dialog-content class="relative">
        <app-input-form [autoFocus]="true"
          inputType="text"
          isRequired="true"
          showLabel="true"
          inputLabel="{{'module.requests.text.request-name' | translate | titlecase}}"
          inputClass="w-100 pb-1h"
          [testId]="'request_name'"
          [placeholder]="placeholder ? (placeholder | translate) : null"
          [formControl]="form.get('name')"></app-input-form>
        <mat-hint *ngIf="inputHint" class="color-warning"
          style="margin-top: -29px; font-size: 0.75rem; display: flex; padding-top: 18px; z-index: 99999; position: relative;">
          {{inputHint | translate }}
        </mat-hint>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="w-100 row p-0">
        <div class="col-6 p-0 pr-1">
          <button class="button primary-button w-100"
                  type="submit"
                  data-test-id="button_add_name"
                  (click)="addName()">
            {{ (this.dataItem?.name ? 'common.button.save' : 'common.button.create') | translate }}
          </button>
        </div>
        <div class="col-6 p-0 pl-1">
          <button class="button secondary-button w-100" mat-dialog-close
                  data-test-id="button_close_dialog"
                  (click)="close()"
                  type="button">{{'common.button.cancel' | translate}}</button>
        </div>
      </div>
    </mat-dialog-actions>
  </form>
</div>
